export default __webpack_public_path__ + "static/media/thats-smart.0d21690a.gif";